// extracted by mini-css-extract-plugin
module.exports = {"Message":"MessageItem_Message__c8Pn9","MessageTime":"MessageItem_MessageTime__-W1GV","MessageImg":"MessageItem_MessageImg__2CIFy"};